import React from 'react';
import { Icon, Text } from '@simplybusiness/mobius';
import { NavLink } from './navLinks';
import './NavContent.css';

export type NavButtonProps = NavLink & {
  isActive: boolean;
  onClick: (href: string) => void;
  testId: string;
};

const NavButton = ({
  label,
  href,
  icon,
  isActive,
  onClick,
  testId,
}: NavButtonProps) => (
  <button
    type="button"
    className="nav-button"
    aria-current={isActive ? 'page' : undefined}
    onClick={() => onClick(href)}
    data-testid={testId}
  >
    <div className="nav-button-content">
      <div className="nav-button-icon">
        <Icon icon={icon} size="md" aria-hidden="true" />
      </div>
      <Text elementType="p" className="nav-button-text">
        {label}
      </Text>
    </div>
  </button>
);

export default NavButton;
